import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class AdminContact extends DomainObject {
  name;
  email;
  avatarColour;
  avatarInitials;

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      email: observable,
      avatarColour: observable,
      avatarInitials: observable
    });

    this.merge(other);
  }
}

export default AdminContact;

